export default __webpack_public_path__ + "static/media/signal_5.4c62ec0f.mp3";